var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_961_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80786 3.80786C8.80786 2.15101 10.151 0.807861 11.8079 0.807861L53.8079 0.807861C55.4647 0.807861 56.8079 2.15101 56.8079 3.80786V61.8079C56.8079 63.4647 55.4647 64.8079 53.8079 64.8079H11.8079C10.151 64.8079 8.80786 63.4647 8.80786 61.8079L8.80786 3.80786Z",
    fill: "#F9FAFB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80786 3.80786C8.80786 2.15101 10.151 0.807861 11.8079 0.807861L53.8079 0.807861C55.4647 0.807861 56.8079 2.15101 56.8079 3.80786V61.8079C56.8079 63.4647 55.4647 64.8079 53.8079 64.8079H11.8079C10.151 64.8079 8.80786 63.4647 8.80786 61.8079L8.80786 3.80786Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8079 1.20786L53.8079 1.20786C55.2438 1.20786 56.4079 2.37192 56.4079 3.80786V61.8079C56.4079 63.2438 55.2438 64.4079 53.8079 64.4079H11.8079C10.3719 64.4079 9.20786 63.2438 9.20786 61.8079L9.20786 3.80786C9.20786 2.37192 10.3719 1.20786 11.8079 1.20786Z",
    stroke: "#EBECF0",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8079 64.8079H53.8079C55.4647 64.8079 56.8079 63.4647 56.8079 61.8079V59.8079C56.8079 61.4647 55.4647 62.8079 53.8079 62.8079H11.8079C10.151 62.8079 8.80786 61.4647 8.80786 59.8079V61.8079C8.80786 63.4647 10.151 64.8079 11.8079 64.8079Z",
    fill: "#EBECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5354 27.6079V38.8079H21.8714V34.2319H24.0474C26.4314 34.2319 27.6154 32.9199 27.6154 30.9519C27.6154 29.0159 26.4314 27.6079 24.0474 27.6079H19.5354ZM21.8714 32.2959V29.6719H23.7114C24.6714 29.6719 25.2954 30.0079 25.2954 30.9839C25.2954 31.9599 24.6714 32.2959 23.7114 32.2959H21.8714ZM32.379 38.8079C36.603 38.8079 38.267 36.2959 38.267 33.2079C38.267 30.1199 36.603 27.6079 32.379 27.6079H28.939L28.939 38.8079H32.379ZM31.275 29.6719H32.267C34.843 29.6719 35.867 31.2079 35.867 33.2079C35.867 35.2079 34.843 36.7439 32.267 36.7439H31.275L31.275 29.6719ZM46.7279 27.6079L39.8479 27.6079V38.8079H42.1839V34.1359H46.1039V32.0719H42.1839V29.6719H46.7279V27.6079Z",
    fill: "#F63831"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_961_606",
    x: 8.80786,
    y: 0.807861,
    width: 48,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_961_606"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4108777a5b7d84f6aad1df849c1fffc6.svg";
export { ForwardRef as ReactComponent };